import { z } from 'zod/v4'
import { SpreadsheetConfigSchema } from './types.spreadsheet'

export const ColumnSchema = z.object({
  colSpan: z.number().optional(),
  // the field handle
  field: z.string(),
})

export const RowSchema = z.object({
  columns: z.array(ColumnSchema),
})

// Column placement for two-column layout
export const SectionColumnSchema = z.enum(['primary', 'secondary'])

// Subsection schema - nested within a section (no further nesting)
export const FormSubsectionSchema = z.object({
  id: z.string(),
  title: z.string().optional(),
  rows: z.array(RowSchema),
})

export const FormSectionSchema = z.object({
  id: z.string(),
  // undefined = unnamed/default section (no header shown)
  title: z.string().optional(),
  // Which column this section belongs to in two-column mode
  // 'primary' = left column (col-span-8), 'secondary' = right column (col-span-4)
  // When all sections are 'primary' or undefined, layout is single-column (col-span-12)
  column: SectionColumnSchema.optional(),
  rows: z.array(RowSchema),
  // Optional subsections within this section
  subsections: z.array(FormSubsectionSchema).optional(),
  // Optional spreadsheet config for ONE_TO_MANY relation sections
  // Stores column configuration for the embedded spreadsheet
  spreadsheet: SpreadsheetConfigSchema.optional(),
})

export const FormConfigSchema = z.object({
  sections: z.array(FormSectionSchema),
})

// Type exports for convenience
export type FormColumn = z.infer<typeof ColumnSchema>
export type FormRow = z.infer<typeof RowSchema>
export type SectionColumn = z.infer<typeof SectionColumnSchema>
export type FormSubsection = z.infer<typeof FormSubsectionSchema>
export type FormSection = z.infer<typeof FormSectionSchema>
export type FormConfig = z.infer<typeof FormConfigSchema>
